/* The Revvly product glyph. Ink by default (currentColor); blue for what is new; amber and red
   for service problems. Durations live in custom properties so no raw time sits in a rule. */

.Icon {
  --revvly-status-new: var(--rv-info);
  --revvly-status-warn: var(--rv-warning);
  --revvly-status-down: var(--rv-danger);
  --revvly-status-cycle: 6000ms;
  --revvly-status-pulse: 2400ms;

  display: block;
  overflow: visible;
}

.Tile,
.Wave,
.Arrow,
.Layer,
.Pulse {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.Tile {
  stroke: currentcolor;
  stroke-width: 2.2;
}

.Wave {
  stroke: currentcolor;
}

.Arrow {
  stroke: var(--revvly-status-new);
  stroke-width: 2.4;
  animation: revvly-status-nudge var(--revvly-status-cycle) var(--rv-ease-in-out) infinite;
}

.Layer {
  stroke: var(--revvly-status-new);
  stroke-width: 2.2;
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  animation: revvly-status-draw var(--revvly-status-cycle) var(--rv-ease-in-out) infinite;
}

.Front {
  animation: revvly-status-settle var(--revvly-status-cycle) var(--rv-ease-in-out) infinite;
}

.degraded .Tile,
.degraded .Wave {
  stroke: var(--revvly-status-warn);
}

.Pulse {
  stroke: var(--revvly-status-warn);
  stroke-width: 2;
  transform-box: fill-box;
  transform-origin: center;
  animation: revvly-status-pulse var(--revvly-status-pulse) var(--rv-ease-in-out) infinite;
}

.down .Tile,
.down .Wave {
  stroke: var(--revvly-status-down);
}

/* A broken line: the signal is lost. */
.Broken {
  stroke-dasharray: 2.4 3;
}

.StillDot {
  display: none;
  fill: var(--revvly-status-new);
}

/* Three quick nudges, then rest for the rest of the cycle. */
@keyframes revvly-status-nudge {
  0%,
  32%,
  100% {
    transform: translateY(0);
  }

  5%,
  15%,
  25% {
    transform: translateY(-2.6px);
  }

  10%,
  20% {
    transform: translateY(0);
  }
}

/* A new layer draws itself onto the stack, holds, then fades to draw again. */
@keyframes revvly-status-draw {
  0% {
    opacity: 100%;
    stroke-dashoffset: 1;
  }

  16% {
    stroke-dashoffset: 0;
  }

  88% {
    opacity: 100%;
    stroke-dashoffset: 0;
  }

  100% {
    opacity: 0%;
    stroke-dashoffset: 0;
  }
}

/* The front tile gives as the new layer lands on it. */
@keyframes revvly-status-settle {
  0%,
  12%,
  24%,
  100% {
    transform: translate(0, 0);
  }

  17% {
    transform: translate(-1.2px, 1.2px);
  }
}

@keyframes revvly-status-pulse {
  0% {
    opacity: 70%;
    transform: scale(1);
  }

  100% {
    opacity: 0%;
    transform: scale(1.28);
  }
}

@media (prefers-reduced-motion: reduce) {
  .Arrow,
  .Layer,
  .Front,
  .Pulse {
    animation: none;
  }

  .Layer {
    stroke-dashoffset: 0;
  }

  .Pulse {
    opacity: 0%;
  }

  .StillDot {
    display: inline;
  }
}
